module.exports = __webpack_public_path__ + "img/corpuls_corpuls3.3fa694bb.png";